import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import AppHome from "./pages/AppHome";
import Network from "./pages/Network";
import Jobs from "./pages/Jobs";
import Messages from "./pages/Messages";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import AccountSetting from "./pages/AccountSetting";
import NotificationsSetting from "./pages/NotificationsSetting";
import PrivacyAndSafety from "./pages/PrivacyAndSafety";
import Communications from "./pages/Communications";
import MessagingSettings from "./pages/MessagingSettings";
import CloseAccount from "./pages/CloseAccount";
import SignUpMemberCreation from "./pages/SignUpMemberCreation";
import ProfileInformation from "./pages/ProfileInformation";
import Display from "./pages/Display";
import GeneralPreferences from "./pages/GeneralPreferences";
import CommunityInner from "./pages/CommunityInner";
import CommunityGroupForm from "./pages/CommunityGroupForm";
import CommunityEventForm from "./pages/CommunityEventForm";
import Community from "./pages/Community";
import ResetPassword from "./pages/ResetPassword";
import PostView from "./pages/PostView";
import Chess from "./pages/Chess/Chess";
import JobBoardHomepage from "./pages/JobBoardHomepage";
import { DarkModeProvider } from "./contexts/useDarkModeContext";
import Companies from "./pages/Companies";
import CreateCompany from "./components/JobBoardCompanies/CreateCompany";
import CompanyDetailsPage from "./pages/CompanyDetailsPage";
import JobDetails from "./components/JobBoardCompanies/JobDetails";

function App() {
  return (
    <DarkModeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="home/app-home" />} />
          <Route path="/" element={<Home />}>
            <Route path="home" element={<Navigate replace to="app-home" />} />
            <Route path="home/app-home" element={<AppHome />} />
            <Route path="home/chess" element={<Chess />} />
            <Route path="home/jobs" element={<Jobs />} />
            <Route path="home/messages" element={<Messages />} />
            <Route path="home/notifications" element={<Notifications />} />
            <Route path="/account" element={<AccountSetting />} />
            <Route
              path="/notifications-setting"
              element={<NotificationsSetting />}
            />
            <Route path="/privacy-and-safety" element={<PrivacyAndSafety />} />
            <Route path="/communications" element={<Communications />} />
            <Route path="/messaging-setting" element={<MessagingSettings />} />
            <Route path="/close-account" element={<CloseAccount />} />
            <Route
              path="/profile-information"
              element={<ProfileInformation />}
            />
            <Route path="/display" element={<Display />} />
            <Route
              path="/general-preferences"
              element={<GeneralPreferences />}
            />
            <Route path="/community" element={<Community />} />
            <Route path="/community-inner" element={<CommunityInner />} />
            <Route
              path="/community-group-form"
              element={<CommunityGroupForm />}
            />
            <Route
              path="/community-event-form"
              element={<CommunityEventForm />}
            />

            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/post/:postId" element={<PostView />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUpMemberCreation />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/job-board-homepage" element={<JobBoardHomepage />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/create-company" element={<CreateCompany />} />
          <Route path="/company-details" element={<CompanyDetailsPage />} />
          <Route path="/job-details" element={<JobDetails />} />
        </Routes>
      </BrowserRouter>
    </DarkModeProvider>
  );
}

export default App;
